import { jsx } from 'react/jsx-runtime';
import { Carousel, CarouselSlide, FluidImage } from '@vp/swan';
import 'react';

const ProductImageCarousel=({images})=>{return jsx(Carousel,{slidesToShow:1,progressIndicator:"dots",accessibleTextForPrevious:"Go to previous slide",accessibleTextForNext:"Go to next slide",accessibleTextForDots:images.map(image=>image.title||image.name),"data-cy":"product-image-caroussel",children:images.map((image,index)=>jsx(CarouselSlide,{"data-cy":"product-image-caroussel-slide",children:jsx(FluidImage,{src:image.src,srcSet:image.srcSet})},`product-image-carousel-${index}-${image.name}`))})};

export { ProductImageCarousel };
//# sourceMappingURL=ProductImageCarousel.js.map
